import Button from "../button";

const ExternalTooltip = ({
  title,
  description,
  confirm,
  onConfirm,
  children,
}) => {
  const handleConfirm = () => {
    onConfirm?.();
  };

  return (
    <>
      <div className={"relative"}>
        {children}
        <div className="z-20 w-[319px] absolute top-full left-1/2 mt-0 -translate-x-1/2 text-white transition duration-150 ease-in-out">
          <div className="h-0 w-0 border-x-8 border-x-white border-b-[12px] border-b-blue-500 mx-auto"></div>
          <div
            className={"bg-blue-500 rounded shadow-lg p-4 flex flex-col gap-3"}
          >
            <div className="text-lg">{title}</div>
            <div className="text-sm">{description}</div>
            {!confirm && (
              <div className="flex justify-end">
                <Button color={"BLUE"} size={"SM"} onClick={handleConfirm}>
                  D'accord
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExternalTooltip;
